var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIbkrMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6462_17945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 56.4231H13.9609V29.166L38.7719 56.4231Z",
    fill: "url(#paint0_linear_6462_17945)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2776 43.2324C39.3789 43.2324 42.7036 39.9077 42.7036 35.8064C42.7036 31.7051 39.3789 28.3804 35.2776 28.3804C31.1763 28.3804 27.8516 31.7051 27.8516 35.8064C27.8516 39.9077 31.1763 43.2324 35.2776 43.2324Z",
    fill: "#D81222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7719 0.42334L13.9609 29.166V56.4233L38.7719 0.42334Z",
    fill: "#D81222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6462_17945",
    x1: 38.7394,
    y1: 42.7952,
    x2: 13.9224,
    y2: 42.7952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#960B1A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6462_17945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbkrMark);
export default __webpack_public_path__ + "static/media/ibkr-mark.6a0b8db3ebf3e09ca51c1351200fc037.svg";
export { ForwardRef as ReactComponent };